import React, { useReducer, useState } from 'react'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Radio,
  RadioGroup,
  Panel,
  Form,
  Message,
  Input,
} from 'rsuite'
import { isValidators, isRequired, getMaxLengthData } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import ShowLimitLength from '../../utils/ShowLimitLength'

export default function ReviewSummaryResultForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  reset,
  clearErrors,
  getValues
}) {
  const [schema, setSchema] = useState(_schema)

  const [_, forceUpdate] = useReducer((x) => x + 1, 0)

  const renderPanel = (item, haveField = true) => {
    const key = item.projectFeedbackId ? 
      `${item.id}_${item.projectFeedbackId}` 
      : item.id;
    
    return (
      <Panel header={item.label} collapsible defaultExpanded>
        <FormGroup>
          {/* {schema.reviewType !== 2 &&
            item.comment?.map((message) => {
              return (
                <Message
                  key={message.reviewerId}
                  type={message.messageType}
                  description={message.description}
                />
              )
            })} */}
          {haveField && (
            <>
              <ErrorMessage error={errors?.reviewFormList?.[key]} />
              <ControlLabel
                className={classNames(isRequired(item.validators) && 'required')}
                style={{ marginTop: 10 }}
              >
                {'ความเห็นผู้ทรงคุณวุฒิ'}
              </ControlLabel>
              <Input
                name={`reviewFormList.[${key}]`}
                componentClass="textarea"
                rows={3}
                style={{ width: '100%', resize: 'auto' }}
                defaultValue={item.value}
                inputRef={register(isValidators(item.validators))}
                placeholder={item.placeholder}
                disabled={item.disabled}
                onChange={(value) => {
                  setValue(`reviewFormList.[${key}]`, value)
                  forceUpdate()
                }}
                maxLength={getMaxLengthData(item?.validators)?.value}
              />
              <ShowLimitLength
                textLength={getValues(`reviewFormList.[${key}]`)?.length || 0}
                maxLength={getMaxLengthData(item?.validators)?.value || 4000}
              />
            </>
          )}
        </FormGroup>
      </Panel>
    )
  }

  return (
    <>
      {schema.reviewForm.map((item) => renderPanel(item))}
      {/* {renderPanel(schema.background)}
      {renderPanel(schema.objective)}
      {renderPanel(schema.periodAndPlan)}
      {renderPanel(schema.targetGroup)}
      {renderPanel(schema.budget)}
      {renderPanel(schema.monitoring)}
      {renderPanel(schema.expectedResult)}
      {renderPanel(schema.otherComment)}
      {renderPanel(schema.summaryResult, false)} */}
    </>
  )
}
